export enum SaleProgressSetting {
  ExcludeNoSaleSaleLots = "ExcludeNoSaleSaleLots",
  ExcludeDeceasedSaleLots = "ExcludeDeceasedSaleLots",
  ExcludeWithdrawnSaleLots = "ExcludeWithdrawnSaleLots",
}
